import { Amplify } from 'aws-amplify';

export async function configureAmplify() {
    Amplify.configure({
        Auth: {
            Cognito: {
                userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
                userPoolClientId: import.meta.env.VITE_COGNITO_USER_POOL_CLIENT_ID,
                loginWith: {
                    oauth: {
                        domain: import.meta.env.VITE_COGNITO_DOMAIN,
                        scopes: ['email', 'openid', 'profile'],
                        redirectSignIn: [window.location.origin],
                        redirectSignOut: [window.location.origin],
                        responseType: 'code' as const,
                    },
                    username: true,
                    email: true,
                },
            },
        },
        API: {
            REST: {
                PolicyTracker: {
                    endpoint: import.meta.env.VITE_API_URL,
                    region: import.meta.env.VITE_AWS_REGION,
                },
            },
        },
    });
}
